
const DefaultImages = {
    full: {
        colorful: 'assets/images/full-colorful.png',
        white: 'assets/images/full-white.png'
    },
    icon: {
        colorful: 'assets/images/icon-colorful.png',
        white: 'assets/images/icon-white.png'
    }
};

export default DefaultImages;

